<template>
  <div>
    <v-card flat>
      <v-tabs centered>
        <v-tab @click="tab = 2">
          <v-icon left>mdi-home-variant</v-icon>
          Grupo de Separação
        </v-tab>
        <v-tab @click="tab = 3">
          <v-icon left>mdi-home-group</v-icon>
          Filiais de Separação
        </v-tab>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <GrupoSeparacao />
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <GrupoSeparacaoFilial :atualizar="tab" />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import GrupoSeparacao from "@/components/drp/configDrpAutomatizado/GrupoSeparacao/Index.vue";
import GrupoSeparacaoFilial from "@/components/drp/configDrpAutomatizado/GrupoSeparacaoFilial";

export default {
  components: {
    GrupoSeparacao,
    GrupoSeparacaoFilial
  },
  data: () => ({
    tab: null
  })
}
</script>

<style>

</style>
